import { __assign, __rest } from "tslib";
import React from 'react';
import { DisplayType } from '@at/design-system-foundation';
import { Link as ATDSLink, Schema } from '@at/design-system-elements';
import { buildBreadcrumbSchema } from './breadcrumb.utils';
import { StyledATDSContainer, StyledBreadcrumb, StyledBreadcrumbsList, StyledCurrentPage } from './breadcrumbs.styled';
export var ATDSBreadcrumbs = function (_a) {
    var className = _a.className, pathSegments = _a.pathSegments, inverted = _a.inverted, lastChildEllipsis = _a.lastChildEllipsis, attributes = _a.attributes, otherHTMLProperties = __rest(_a, ["className", "pathSegments", "inverted", "lastChildEllipsis", "attributes"]);
    if (!pathSegments || pathSegments.length === 0)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Schema, { schema: buildBreadcrumbSchema(pathSegments) }),
        React.createElement(StyledATDSContainer, __assign({ className: className, displayType: DisplayType.CONSTRAINED }, attributes, otherHTMLProperties),
            React.createElement(StyledBreadcrumb, { inverted: inverted, lastChildEllipsis: lastChildEllipsis, as: "nav" },
                React.createElement(StyledBreadcrumbsList, { "data-testid": "breadrumb-list" }, pathSegments.map(function (_a, index) {
                    var copy = _a.copy, link = _a.link, _b = _a.inAppLink, inAppLink = _b === void 0 ? false : _b;
                    var isLast = index === pathSegments.length - 1;
                    var isLink = !!link;
                    if (isLast || !isLink)
                        return (React.createElement("li", { key: index },
                            React.createElement(StyledCurrentPage, { inverted: inverted }, copy)));
                    return (React.createElement("li", { key: index },
                        React.createElement(ATDSLink, { href: link, routerLink: inAppLink }, copy)));
                }))))));
};
export default ATDSBreadcrumbs;
